<template>
  <div class="app bg-gray" id="register-registConfirm">
    <section class="doctor-info">
      <div
        class="head doc-header"
        v-bind:style="{
          backgroundImage:
            'url(' +
            (registInfo.schedule.doctAvatar
              ? registInfo.schedule.doctAvatar
              : '../../../static/img/ico-doctor.png') +
            ')',
        }"
      >
        <!-- 门诊类型标签 -->
        <span
          v-if="registInfo.schedule.typeId === '849772'"
          class="type-tag tag-putong"
          >{{ registInfo.schedule.typeName }}</span
        >
        <span
          v-if="registInfo.schedule.typeId === '643075'"
          class="type-tag tag-zhuanjia"
          >{{ registInfo.schedule.typeName }}</span
        >
      </div>
      <div class="info">
        <p style="padding-right: 0.5rem">
          <span class="f-large f-strong" style="margin-right: 0.25rem">{{
            registInfo.schedule.rankName
          }}</span>
        </p>
        <p class="ellipsis">{{ registInfo.schedule.doctName }}</p>
      </div>
    </section>

    <section>
      <dl class="field">
        <dt>预约科室</dt>
        <dd>{{ registInfo.schedule.deptName }}</dd>
      </dl>
      <dl class="field">
        <dt>医院</dt>
        <dd>{{ hospitalName }}</dd>
      </dl>
      <dl class="field">
        <dt>预约时间</dt>
        <dd>
          {{ registInfo.date.value | formatDate }} &nbsp;{{
            registInfo.date.weekDay
          }}
          &nbsp;{{ registInfo.schedule.timeslot }}
        </dd>
      </dl>
      <dl class="field last">
        <dt>挂号金额</dt>
        <dd style="color: #1d1d26">
          <span style="color: #f24141">{{
            registInfo.schedule.fee | formatFee
          }}</span>
        </dd>
      </dl>
    </section>
    <div
      class="bg-white"
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.3rem;
      "
    >
      <span>选择就诊凭证 </span>
      <button v-show="showAddVoucherBtn" class="btn-ugly" @click="addVoucher">
        +添加就诊凭证
      </button>
    </div>
    <!-- 就诊凭证列表 -->
    <scroll
      class="to-bottom-btn"
      @refresh="loadVouchers"
      style="top: 9rem; margin-top: 0.5rem; background: #fff"
    >
      <div
        v-show="showAddVoucherArea"
        class="flex-row flex-align-center add-voucher-area"
        @click="addVoucher"
      >
        <div class="add-voucher-icon"></div>
        <div class="flex-1 flex-width">
          暂无就诊凭证，请<span class="f-strong">先绑定就诊凭证</span>
        </div>
      </div>
      <voucher-item-small
        v-for="(voucher, index) in vouchers"
        :key="index"
        :voucher="voucher"
        :index="index"
        :class="selectedIndex == index ? 'selected' : 'disabled'"
        @selected="selectVoucher"
      ></voucher-item-small>
      <div class="register-des" v-show="showPrompt">
        <h5 class="reminder">挂号须知</h5>
        <p>1.微信挂号不能享受医保6元诊疗补助。</p>
        <p>
          2.预约挂号时间为参考时间，具体就诊时间以实际时间为准；取消预约至少提前一天，当天不可取消且无法退款。
        </p>
        <p>
          3.预约挂号为实名制绑定电子健康卡使用，就诊时请携带电子健康卡到医院就诊，若未办理电子健康卡请及时办理。
        </p>
      </div>
      <div class="register-des" v-show="!showPrompt">
        <h5 class="reminder">挂号须知</h5>
        <p>1.取消预约至少提前一天，当天不可取消且无法退款。</p>
        <p>
          2.预约挂号为实名制绑定电子健康卡使用，就诊时请携带电子健康卡到医院就诊，若未办理电子健康卡请及时办理。
        </p>
      </div>
    </scroll>
    <message-confirm
      title="请勿重复预约"
      text="请前往我的挂号进行缴费或取消预约"
      action="前往我的挂号"
      v-model="showMessageConfirm"
      @on-action="gotoMyRegister"
    ></message-confirm>
    <payConfirm v-model="showPayConfirm"></payConfirm>
    <footer>
      <button
        class="btn-complete"
        type="button"
        @click="sumbitRegist"
        style="border-radius: 0"
      >
        确认挂号
      </button>
    </footer>
  </div>
</template>
<script>
import utils from 'utils'
import VoucherItemSmall from '../voucher/VoucherItemSmall'
import voucherService from 'voucher.service'
import registerService from 'register.service'
import MessageConfirm from 'MessageConfirm'
import PayConfirm from 'PayConfirm'
export default {
  components: {
    VoucherItemSmall,
    MessageConfirm,
    PayConfirm
  },
  mounted () {
    this.loadVouchers();
  },

  data () {
    var params = this.$store.state.paramModule.param.register;
    return {
      hospitalName: JSON.parse(localStorage.selectedHospital).hospitalName || "",
      hospitalId: JSON.parse(localStorage.selectedHospital).hospitalId || "",
      vouchers: [],
      registInfo: params,
      selectedIndex: 0,
      selectedVoucher: {},
      regDate: '',
      showAddVoucherArea: false,
      showMessageConfirm: false,
      showPayConfirm: false
    }
  },
  computed: {
    showAddVoucherBtn () {
      return this.vouchers.length > 0 && this.vouchers.length < 3;
    },
    showPrompt () {
      return this.hospitalId == '1004'
    }
  },
  methods: {
    loadVouchers: function () {
      voucherService.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        this.vouchers = res.data || [];
        if (this.vouchers.length === 0) {
          this.showAddVoucherArea = true;
          return;
        }
        this.showAddVoucherArea = false;
        //默认第一张诊疗卡
        this.selectedIndex = 0;
        this.selectedVoucher = this.vouchers[0];
      })
    },
    sumbitRegist: function () {
      if (!this.selectedVoucher.cardNo) {
        return utils.alert('请先添加诊疗卡');
      }
      var params = this.$store.state.paramModule.param.register;
      this.regDate = params.date.value;
      var requestParams = {
        cardType: this.selectedVoucher.cardType,
        cardNo: this.selectedVoucher.cardNo,
        areaId: params.area.areaId,
        regDate: params.date.value,
        deptId: params.schedule.deptId,
        doctId: params.schedule.doctId,
        startTime: params.schedule.startTime,
        endTime: params.schedule.endTime,
        phaseId: params.schedule.phaseId,
        regSourceId: params.schedule.regSourceId,
        typeId: params.schedule.typeId,
        ordNum: params.schedule.ordNum
      };
      registerService.registLock(requestParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.submitRegistFailed(res);
          return;
        }
        this.submitRegistSuccess(res);
      })
    },
    submitRegistSuccess: function (response) {

      if (sessionStorage.getItem('localAreaType') === '1') {
        //将数据存入本地
        this.$store.commit('updateParam', {
          namespace: 'pay',
          payInfo: {
            cardType: this.selectedVoucher.cardType,
            cardNo: this.selectedVoucher.cardNo,
            orderType: '1',
            fee: response.data.fee,
            orderId: response.data.orderId,
            busiType: '1'
          }
        });
        this.$store.commit('updateParam', {
          namespace: 'regDetail',
          // 支付完成后跳转到挂号详情所需要的参数
          registerInfo: {
            cardType: this.selectedVoucher.cardType,
            cardNo: this.selectedVoucher.cardNo,
            orderId: response.data.orderId
          }
        });
        //判断是否0元需求
        if (parseFloat(response.data.fee) <= 0) {
          this.zeroPay(response);
          return;
        }
        this.showPayConfirm = true;
      } else {
        //如果市外预约，则不管成功失败都跳转预约结果界面
        this.$store.commit('updateParam', {
          namespace: 'BookingResult',
          // 支付完成后跳转到挂号详情所需要的参数
          registerInfo: {
            bookingResult: true,
            busiType: '1',
            cardType: this.selectedVoucher.cardType,
            cardNo: this.selectedVoucher.cardNo,
            orderId: response.data.orderId,
            fee: this.registInfo.schedule.fee,
          }
        });
        this.$router.push('BookingResult');
      }
    },
    submitRegistFailed: function (response) {
      var errorCode = response.errorCode;
      if (sessionStorage.getItem('localAreaType') === '1') {
        // 通过errorCode区分挂号失败原因
        if (errorCode === 11070028) {
          // 由于重复挂号导致失败，弹窗引导用户跳转到挂号列表
          this.showMessageConfirm = true;
        } else {
          this.$utils.alert("挂号失败: " + response.resultMsg);
        }
      } else {
        this.$store.commit('updateParam', {
          namespace: 'BookingResult',
          // 支付完成后跳转到挂号详情所需要的参数
          registerInfo: {
            message: response.resultMsg,
            bookingResult: false,
            orderId: '暂无订单号',
            fee: this.registInfo.schedule.fee,
          }
        });
        // 通过errorCode区分挂号失败原因
        if (errorCode === 11070028) {
          // 由于重复挂号导致失败，弹窗引导用户跳转到挂号列表
          this.showMessageConfirm = true;
        } else {
          //如果市外预约，跳转预约结果界面
          this.$router.push('BookingResult');
        }
      }
    },
    gotoMyRegister: function () {
      this.showMessageConfirm = false;
      this.$router.push('myregister');
    },
    selectVoucher (voucher, index) {
      this.selectedIndex = index;
      this.selectedVoucher = voucher;
    },

    addVoucher: function () {
      this.$router.push({
        path: 'voucherChooseType'
      });
    },

    //0元需求
    zeroPay (response) {
      // 从上级获取参数
      const params = {
        orderId: response.data.orderId,
        orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE,
        cardType: this.selectedVoucher.cardType,
        cardNo: this.selectedVoucher.cardNo,
        channelId: '4',
        // app 1; h5 2; o2o 3;
        invokeType: this.constant.INVOKE_TYPE.WAP_INVOKE,
        busiType: this.constant.BUSI_TYPE.REGISTRATION_PAYMENT,
        fee: response.data.fee,
        deviceId: this.code,
      }
      // 生成外部订单号
      this.loadOutOrder(params)
    },
    loadOutOrder (params) {
      this.$http.post('/app/pay/order', params).then((res) => {
        if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
          // 跳转支付成功或失败界面
          this.$store.commit('updateParam', {
            namespace: 'paySuccess',
            paySuccessInfo: {
              orderId: params.orderId,
              fee: params.fee,
              busiType: params.busiType,
            },
          })
          this.$router.replace('paySuccess')
        } else {
          this.$utils.alert(res.data.resultMsg)
        }
      })
    },
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";

.add-voucher-area {
  margin: 0.75rem 0.5rem 0;
  padding: 1rem 0.5rem;
  border: 1px dotted $main-style-color;
  background: #fff;
  .add-voucher-icon {
    height: 3rem;
    width: 2.5rem;
    margin-right: 0.5rem;
    background: url("../../../static/img/voucher-add.png") center no-repeat;
    background-size: contain;
  }
}
.register-des {
  color: #f24141;
  background: #eff2f5;
  margin: 0.5rem 0.5rem;
  padding: 0.2rem;

  .reminder {
    width: 4rem;
    background: url("../../../static/img/reminder.png") center left no-repeat;
    background-size: 17px 17px;
    padding-left: 1rem;
  }

  p {
    padding-left: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// RegistConfirm.vue?b0f91712